import { render, staticRenderFns } from "./modal_demo.vue?vue&type=template&id=bf3b6a14&scoped=true&"
import script from "./modal_demo.vue?vue&type=script&lang=ts&"
export * from "./modal_demo.vue?vue&type=script&lang=ts&"
import style0 from "./modal_demo.vue?vue&type=style&index=0&id=bf3b6a14&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3b6a14",
  null
  
)

export default component.exports